import { techinicalService } from "@features/techinicaldocument/TechinicalService";
import { TechinicalOutputDTO } from '@features/techinicaldocument/types';
import createEntitySlice from "@services/createEntitySlice";

const {
  reducer: TechinicalReducer,
  actions: TechinicalActions,
  fetchAll: fetchTechinicals,
  fetchById: fetchTechinicalById,
  createEntity: createTechinical,
  updateEntity: updateTechinical,
  deleteEntity: deleteTechinical,
} = createEntitySlice<TechinicalOutputDTO>("Techinical", techinicalService);

export {
  TechinicalReducer,
  TechinicalActions,
  fetchTechinicals,
  fetchTechinicalById,
  createTechinical,
  updateTechinical,
  deleteTechinical,
}; 